import { isOfType, ProductType, PlannerProductComponent, getProductReferenceFor, ShoppingBagComponent, OuterMeasurementsComponent, HideInSeeThroughSystemComponent, DistanceMeasurementComponent, AssemblyInstructionsComponent } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
import { getWorktop } from '../utils/worktop';
import MoveableWorktopComponent from '../components/MoveableWorktopComponent';
export const knoxhultComponentResolver = (coreApi, _products, _unavailableProducts, _productsNotInMarket, _coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.KNOXHULT_CABINET_ASM,
        ProductType.KNOXHULT_SINK_CABINET_ASM,
        ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM,
        ProductType.KNOXHULT_NICHE_CABINET_ASM,
        ProductType.KNOXHULT_WALL_CABINET_ASM,
        ProductType.KNOXHULT_WALL_GLASS_CABINET_ASM,
        ProductType.KNOXHULT_HIGH_CABINET_ASM,
        ProductType.KNOXHULT_CORNER_CABINET_ASM,
        ProductType.APPLIANCE_INTEGRATED_HOB,
        ProductType.APPLIANCE_INTEGRATED_OVEN,
        ProductType.APPLIANCE_FRIDGE_FREEZER,
        ProductType.APPLIANCE_FREE_HANGING_EXTRACTOR_HOOD,
        ProductType.APPLIANCE_CABINET_EXTRACTOR_HOOD,
        ProductType.HANDLE,
        ProductType.EDGE_HANDLE,
        ProductType.KNOB,
        ProductType.KITCHEN_SINK_ASM,
        ProductType.KITCHEN_TAP,
        ProductType.ENHET_WALL_FRAME
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.KNOXHULT_CABINET_ASM,
        ProductType.KNOXHULT_SINK_CABINET_ASM,
        ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM,
        ProductType.KNOXHULT_NICHE_CABINET_ASM,
        ProductType.KNOXHULT_WALL_CABINET_ASM,
        ProductType.KNOXHULT_WALL_GLASS_CABINET_ASM,
        ProductType.KNOXHULT_HIGH_CABINET_ASM,
        ProductType.KNOXHULT_CORNER_CABINET_ASM,
        ProductType.APPLIANCE_INTEGRATED_HOB,
        ProductType.APPLIANCE_INTEGRATED_OVEN,
        ProductType.APPLIANCE_FRIDGE_FREEZER,
        ProductType.APPLIANCE_FREE_HANGING_EXTRACTOR_HOOD,
        ProductType.APPLIANCE_CABINET_EXTRACTOR_HOOD,
        ProductType.HANDLE,
        ProductType.EDGE_HANDLE,
        ProductType.KNOB,
        ProductType.KITCHEN_SINK_ASM,
        ProductType.KITCHEN_TAP,
        ProductType.ENHET_WALL_FRAME
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([
        ProductType.KNOXHULT_CABINET,
        ProductType.KNOXHULT_WALL_CABINET,
        ProductType.KNOXHULT_HIGH_CABINET,
        ProductType.KNOXHULT_CORNER_CABINET,
        ProductType.KNOXHULT_WORKTOP,
        ProductType.KNOXHULT_DOOR_FRONT,
        ProductType.KNOXHULT_DRAWER_FRONT,
        ProductType.APPLIANCE_FRIDGE_FREEZER,
        ProductType.APPLIANCE_FREE_HANGING_EXTRACTOR_HOOD,
        ProductType.ENHET_WALL_FRAME
    ]);
    const isFrame = isOfType([
        ProductType.KNOXHULT_CABINET_ASM,
        ProductType.KNOXHULT_SINK_CABINET_ASM,
        ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM,
        ProductType.KNOXHULT_NICHE_CABINET_ASM,
        ProductType.KNOXHULT_WALL_CABINET_ASM,
        ProductType.KNOXHULT_WALL_GLASS_CABINET_ASM,
        ProductType.KNOXHULT_HIGH_CABINET_ASM,
        ProductType.KNOXHULT_CORNER_CABINET_ASM,
        ProductType.ENHET_WALL_FRAME
    ]);
    const shouldHaveDistanceMeasurement = isOfType([
        ProductType.KNOXHULT_CABINET_ASM,
        ProductType.KNOXHULT_SINK_CABINET_ASM,
        ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM,
        ProductType.KNOXHULT_NICHE_CABINET_ASM,
        ProductType.KNOXHULT_WALL_CABINET_ASM,
        ProductType.KNOXHULT_WALL_GLASS_CABINET_ASM,
        ProductType.KNOXHULT_HIGH_CABINET_ASM,
        ProductType.KNOXHULT_CORNER_CABINET_ASM,
        ProductType.APPLIANCE_FREE_HANGING_EXTRACTOR_HOOD,
        ProductType.APPLIANCE_CABINET_EXTRACTOR_HOOD,
        ProductType.APPLIANCE_FRIDGE_FREEZER,
        ProductType.ENHET_WALL_FRAME
    ]);
    const shouldHaveAssemblyInstructions = isOfType([
        ProductType.KNOXHULT_CABINET_ASM,
        ProductType.KNOXHULT_SINK_CABINET_ASM,
        ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM,
        ProductType.KNOXHULT_NICHE_CABINET_ASM,
        ProductType.KNOXHULT_WALL_CABINET_ASM,
        ProductType.KNOXHULT_WALL_GLASS_CABINET_ASM,
        ProductType.KNOXHULT_HIGH_CABINET_ASM,
        ProductType.KNOXHULT_CORNER_CABINET_ASM,
        ProductType.APPLIANCE_FREE_HANGING_EXTRACTOR_HOOD,
        ProductType.APPLIANCE_CABINET_EXTRACTOR_HOOD,
        ProductType.APPLIANCE_FRIDGE_FREEZER,
        ProductType.ENHET_WALL_FRAME
    ]);
    const hasMoveableWorktop = isOfType([
        ProductType.KNOXHULT_CABINET_ASM,
        ProductType.KNOXHULT_SINK_CABINET_ASM,
        ProductType.KNOXHULT_SINK_AND_OVEN_CABINET_ASM,
        ProductType.KNOXHULT_NICHE_CABINET_ASM
    ]);
    const componentBuilder = {
        build: (entity) => {
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (isPlannerProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
            }
            if (shouldHaveDistanceMeasurement(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN, Direction.LEFT, Direction.RIGHT], [], false));
            }
            if (isFrame(entity)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
            }
            if (shouldHaveAssemblyInstructions(entity)) {
                entity.addComponent(new AssemblyInstructionsComponent());
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (hasMoveableWorktop(entity)) {
                /**
                 * For cabinets with moveable worktop, we remove the collider shape component so the
                 * cabinet can align with other cabinets. The AlignWorktopValidation and AlignWorktopSystem
                 * will handle the snapping, moving worktop and adding the collider shape component again.
                 */
                entity.addComponent(new MoveableWorktopComponent());
                const worktop = getWorktop(entity, coreApi);
                if (worktop) {
                    worktop.removeComponent(ComponentIds.COLLIDER_SHAPE_COMPONENT_ID);
                }
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=knoxhultComponentResolver.js.map